<div class="container">
  <div class="columns is-multiline">
    <div class="column is-narrow" *ngFor="let image of lacertaGalleryImages as galleryImages; let i = index">
      <lacerta-gallery-image [images]="galleryImages" [imageIndex]="i"></lacerta-gallery-image>
    </div>
  </div>
</div>
